/**
 * Created by user on 2019/6/9.
 */

export default exports as typeof import('./rfc6570');
